/**
 * Chat widget event names
 * Centralized location for all chat widget event constants
 */
export const CHAT_REQUEST = 'chatRequest';
export const CHAT_BOT_REQUEST = 'chatBotRequest';
export const CHAT_RESPONSE = 'chatResponse';
export const CLOSE_CHAT = 'closeChat';
export const START_LIVECHAT_REQUESTED = 'startLivechatRequested';

// Legacy object export for backward compatibility (can be removed later)
export const CHAT_WIDGET_EVENTS = {
  CHAT_REQUEST,
  CHAT_BOT_REQUEST,
  CHAT_RESPONSE,
  CLOSE_CHAT,
  START_LIVECHAT_REQUESTED
} as const;

export type ChatWidgetEvent = typeof CHAT_WIDGET_EVENTS[keyof typeof CHAT_WIDGET_EVENTS];